import { Box } from '@mui/material';
import { LabeledValue, LabelIdValue } from '~/components/Fields/LabeledValue';
import ReviewStatus from '~/components/Structures/ReviewStatus';
import { DICOMApprovalStatus, Roi } from '~/domain/dicom/dicomstructureset';
import { StructureSet } from '~/domain/patient/structureset';
import { formatDateString } from '~/utils/date';
import StructuresTable from './StructuresTable';

export default function StructureSetExportDetails({
    structureSet,
    selectedStructures,
    onSelectStructure,
}: {
    structureSet: StructureSet;
    selectedStructures: Roi[];
    onSelectStructure: (structure: Roi) => void;
}) {
    return (
        <Box display="grid" gap={2}>
            <Box display="grid" gap={1}>
                <Box py={1} display="grid" gap={1}>
                    <Box display="grid" gridTemplateColumns="1fr 1fr 1fr">
                        <LabeledValue
                            label="Name"
                            value={structureSet.structureSetLabel}
                        />
                        <LabeledValue
                            label="Structures"
                            value={structureSet.roiArray.length}
                        />
                        <LabelIdValue
                            label="SOP Instance UID"
                            id={structureSet.dicomUid ?? ''}
                        />
                    </Box>
                    <Box display="grid" gridTemplateColumns="1fr 1fr 1fr">
                        <LabeledValue
                            label="Approval status"
                            value={
                                <ReviewStatus
                                    status={structureSet.approvalStatus}
                                />
                            }
                        />
                        {structureSet.approvalStatus ===
                            DICOMApprovalStatus.APPROVED && (
                            <>
                                <LabeledValue
                                    label="Reviewer name"
                                    value={
                                        structureSet.dicomStructureSet
                                            .reviewerName.length
                                            ? structureSet.dicomStructureSet
                                                  .reviewerName
                                            : 'Unknown'
                                    }
                                />
                                <LabeledValue
                                    label="Review Date"
                                    value={formatDateString(
                                        structureSet.dicomStructureSet
                                            .reviewDate
                                    )}
                                />
                            </>
                        )}
                    </Box>
                </Box>
                <StructuresTable
                    structures={structureSet.roiArray ?? []}
                    selectedStructures={selectedStructures}
                    onSelect={onSelectStructure}
                />
            </Box>
        </Box>
    );
}
